module.exports = __webpack_public_path__ + "static/img/caret-down.79127290.svg";